import React, { useState, useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist/webpack";

export function PdfToPngConverter({ pdfUrl, status,  onStatusChange, setImageUrl, tabIndex, updatePNGImageUrl, externalLink=false }) {
    const [pngUrl, setPngUrl] = useState(null);
    const [plotState, setPlotState] = useState(status);
    const canvasRef = useRef(null);

    const setImageStatus = (status) => {
        onStatusChange(status);
        setPlotState(status);
    };


    useEffect(() => {

        const tryConvert = () => {
            const canvas = canvasRef.current;
            if (!canvas) {
                console.log("canvas not found");
                setTimeout(tryConvert, 50); // retry after 50ms
                return;
            }
            convertPdfToPng(pdfUrl, externalLink, canvas);
        };

        tryConvert();
    }, [pdfUrl]);

    const convertPdfToPng = async (pdfUrl, externalLink, canvas) => {
        try {

            if (!externalLink) {
                setImageStatus("loading");
            } else {
                setImageStatus("enhancing");
            }

            const loadingTask = pdfjsLib.getDocument(pdfUrl);

            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1); // Render first page only

            const scale = 2; // Increase resolution for better quality
            const viewport = page.getViewport({ scale });
            //const canvas = canvasRef.current;

            const ctx = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = {
                canvasContext: ctx,
                viewport: viewport,
            };

            await page.render(renderContext).promise;

            // Convert Canvas to PNG
            const pngDataUrl = canvas.toDataURL("image/png");
            setPngUrl(pngDataUrl);
            setImageUrl(pngDataUrl);
            onStatusChange("success");
            setPlotState("success");
            updatePNGImageUrl(tabIndex, pngDataUrl);

        } catch (error) {
            const errorMessage = error?.message || String(error);
            console.error("PDF Conversion", errorMessage);

            if (errorMessage.includes("Cannot use the same canvas during multiple render() operations")) {
                onStatusChange("enhancing");
                setPlotState("enhancing");
                return;
            }

            onStatusChange("error");
            setPlotState("error");
        }
    };

    return (
        <div>
          {/* Hidden Canvas for Conversion */}
          <canvas ref={canvasRef} style={{ display: "none" }} />
        </div>
    );
}


export async function convertPdfImageToPngImage(pdfBlob) {
    return new Promise(async (resolve, reject) => {
        try {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(pdfBlob);
            fileReader.onload = async function () {
                const pdfData = new Uint8Array(fileReader.result);
                const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
                const page = await pdf.getPage(1);

                const scale = 2;
                const viewport = page.getViewport({ scale });
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                await page.render({ canvasContext: ctx, viewport }).promise;

                // Convert canvas to PNG blob
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, "image/png");
            };
        } catch (error) {
            reject(error);
        }
    });
};
